import logo from 'assets/images/thor-logo.png';

// ==============================|| LOGO ||============================== //

const Logo = () => {
  return <img src={logo} alt="Thor" width="140" height="auto" style={{ display: 'block' }} />;
};

export default Logo;
